module.exports = {
  "country": "IL",
  "artist": "Eden Golan",
  "song": "Hurricane",
  "year": "2024",
  "place": "5",
  "spotify": "2Ozw7k5CLtM5W9SomrOyjw"
};